module.exports = __webpack_public_path__ + "img/020-hockey.b66cac0e.png";